define((require) => {
    "use strict";

    var Backbone               = require("backbone"),
        SalesforceCommerceProductModel = require("../model/SalesforceCommerceProductModel");

    /**
     * A collection of Products.
     *
     * @author Pedro Augusto
     * @class SalesforceCommerceProductCollection
     * @constructor
     */
    return Backbone.Collection.extend("SalesforceCommerceProductCollection", {
        /**
         * @type SalesforceCommerceProductModel
         */
        model: SalesforceCommerceProductModel
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/model/SalesforceCommerceProductCollection.js